import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { AccountContext } from "context/account";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import Chip from "@mui/material/Chip";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Grid from "@mui/material/Grid";
import Slider from "@mui/material/Slider";
import TitleIcon from "@mui/icons-material/Title";
import HighlightAltIcon from "@mui/icons-material/HighlightAlt";
import ClothIcon from "components/Icon/ClothIcon";
import IconButton from "@mui/material/IconButton";
import ButtonGroup from "@mui/material/ButtonGroup";

import CropLandscapeIcon from "@mui/icons-material/CropLandscape";
import CropPortraitIcon from "@mui/icons-material/CropPortrait";
import CropSquareIcon from "@mui/icons-material/CropSquare";

import toast from "react-hot-toast";

import api from "services/api";
import moment from "moment";

import { Divider } from "antd";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import AddFashionTagModal from "pages/fashionlab/components/AddFashionTagModal";
import AddMiniFashionTagModal from "pages/fashionlab/components/AddMiniFashionTagModal";

import InspirePromptTagModal from "pages/fashionlab/components/InspirePromptTagModal";
import InspirePromptModal from "pages/fashionlab/components/InspirePromptModal";

import { modelMap, promptTags } from "utils/data";
import SuiSelect from "components/SuiSelect";

const aspectRatioOptions = [
  {
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
        <CropPortraitIcon fontSize="medium" />
        Portrait(3:4)
      </div>
    ),
    value: "912*1216",
  },
  {
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
        <CropLandscapeIcon fontSize="medium" /> Landscape(4:3)
      </div>
    ),
    value: "1216*912",
  },

  {
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
        <CropSquareIcon fontSize="medium" />
        Square(1:1)
      </div>
    ),
    value: "1024*1024",
  },
];

const DesignToolsCard = ({
  jobconf,
  setJobconf,
  handleClickModel,
  uploadFabricRef,
  uploadSketchRef,
  sketchData,
  promptRef,
  viewType,
  handleChangeViewType,
}) => {
  const [selectedCat, setSelectedCat] = useState(promptTags[0]["value"]);
  const [addFashionTagVisible, setAddFashionTagVisible] = useState(false); //inspire fashion tags
  const [inspiredTagsVisible, setInspiredTagsVisible] = useState(false);
  const [addMiniFashionTagVisible, setAddMiniFashionTagVisible] = useState(false);
  const [tagSubOptions, setTagSubOptions] = useState([]);
  const [inspireVisible, setInspireVisible] = useState(false); //inspire fashion prompts

  const findAspectOption =
    aspectRatioOptions.find((x) => x.value == jobconf?.aspect_ratio) || aspectRatioOptions[0];

  const renderTags = (cat) => {
    const findIndex = promptTags.findIndex((s) => s.value == cat);
    if (findIndex > -1) {
      let tags = promptTags[findIndex].children || [];
      if (tags.length > 12) {
        tags = tags.slice(0, 12);
      }

      return (
        <div>
          {tags.map((tag) => (
            <Chip
              avatar={tag?.img ? <Avatar src={tag?.img} /> : null}
              label={tag.label}
              variant="outlined"
              size="small"
              color={
                jobconf?.prompt_array && jobconf?.prompt_array.includes(tag.value)
                  ? "primary"
                  : "default"
              }
              onClick={(e) => handleTogglePromptArray(tag)}
              sx={{ mr: 0.5, mb: 0.5, fontSize: 11, borderRadius: 1 }}
            />
          ))}
          {promptTags[findIndex].children.length > 12 ? (
            <Chip
              avatar={null}
              label={"More..."}
              variant="contained"
              size="small"
              color={"secondary"}
              onClick={(e) => {
                setAddMiniFashionTagVisible(true);
                setTagSubOptions(promptTags[findIndex].children);
              }}
              sx={{ mr: 0.5, mb: 0.5, fontSize: 11, borderRadius: 1 }}
            />
          ) : null}
        </div>
      );
    }
  };

  const handleTogglePromptArray = (item) => {
    setJobconf((prev) => {
      const myArray = prev?.prompt_array || [];
      let prompt_array = [...myArray];
      const findIndex = prompt_array.findIndex((x) => x == item.value);
      if (findIndex > -1) {
        prompt_array.splice(findIndex, 1);
      } else {
        prompt_array.push(item.value);
      }

      return { ...prev, prompt_array };
    });
  };

  return (
    <SuiBox>
      <Card sx={{ borderRadius: 1, mb: 2, zIndex: 2, boxShadow: ({ boxShadows: { md } }) => md }}>
        <Grid container>
          {modelMap
            .filter((x) => !x.hide)
            .map((item, index) => (
              <Grid
                item
                lg={6}
                md={6}
                sm={6}
                xs={6}
                key={index}
                onClick={() => {
                  handleClickModel(item);
                }}
              >
                <SuiBox
                  className={
                    jobconf.task_type == item.value
                      ? "model-function-button-active"
                      : "model-function-button-inactive"
                  }
                  sx={{
                    textAlign: "center",
                    width: "100%",
                    height: "100%",
                    margin: "auto",
                    lineHeight: 1.2,
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#f3f3f3",
                    },
                  }}
                >
                  {item.icon}
                  <SuiBox
                    sx={{
                      display: { xs: "none", sm: "none", md: "flex", lg: "flex" },
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 13,
                    }}
                  >
                    {item.label}
                  </SuiBox>
                </SuiBox>
              </Grid>
            ))}
        </Grid>

        {jobconf.task_type != "fabric" ? (
          <SuiBox>
            <SuiBox sx={{ px: 1, py: 1 }}>
              <SuiBox display="flex" alignItems="center" justifyContent="space-between">
                <SuiTypography variant="body1" sx={{ mb: 1 }}>
                  Filter:
                </SuiTypography>
              </SuiBox>
              <SuiBox display="flex" flexWrap="wrap" gap={1}>
                {promptTags.slice(0, 8).map((cat) => (
                  <SuiButton
                    variant={selectedCat == cat.value ? "contained" : "outlined"}
                    size="xsmall"
                    color={selectedCat == cat.value ? "info" : "dark"}
                    sx={{
                      textTransform: "capitalize",
                      padding: "5px 5px",
                      fontWeight: "regular",
                      minHeight: 5,
                      fontSize: 12,
                    }}
                    onClick={() =>
                      cat.value == selectedCat ? setSelectedCat(null) : setSelectedCat(cat.value)
                    }
                  >
                    {cat.label}
                  </SuiButton>
                ))}
                <SuiButton
                  variant={"contained"}
                  size="xsmall"
                  color={"secondary"}
                  sx={{
                    textTransform: "capitalize",
                    padding: "5px 5px",
                    fontWeight: "regular",
                    minHeight: 5,
                    fontSize: 12,
                  }}
                  onClick={() => {
                    setAddFashionTagVisible(true);
                  }}
                >
                  More...
                </SuiButton>
              </SuiBox>

              {selectedCat ? <Divider style={{ margin: 10 }} /> : null}
              <SuiBox display="flex" flexWrap="wrap" gap={0.2}>
                {renderTags(selectedCat)}
              </SuiBox>
            </SuiBox>
            {/* <SuiBox
              display="flex"
              gap={0.5}
              alignItems="center"
              justifyContent="space-evenly"
              mb={1}
              sx={{ flexWrap: "wrap" }}
            >
              <SuiButton
                onClick={() => {
                  if (
                    promptRef?.current?.value ||
                    (jobconf?.prompt_array && jobconf.prompt_array.length > 0)
                  ) {
                    setInspiredTagsVisible(true);
                  } else {
                    toast.error("Please input some keywords or select some tags! ");
                  }
                }}
                variant="contained"
                size="small"
                color="dark"
                sx={{
                  padding: "0px 8px",
                  fontSize: 12,
                  lineHeight: 0,
                  minHeight: 30,
                  width: "40%",
                  textTransform: "capitalize",
                  borderRadius: "4px",
                  mb: 0.5,
                }}
              >
                AI Tags
              </SuiButton>
              <SuiButton
                onClick={() => {
                  if (
                    promptRef?.current?.value ||
                    (jobconf?.prompt_array && jobconf.prompt_array.length > 0)
                  ) {
                    setInspireVisible(true);
                  } else {
                    toast.error("Please input some keywords or select some tags! ");
                  }
                }}
                variant="contained"
                size="small"
                color="dark"
                sx={{
                  padding: "0px 8px",
                  fontSize: 12,
                  lineHeight: 0,
                  minHeight: 30,
                  width: "40%",
                  minWidth: 90,
                  textTransform: "capitalize",
                  borderRadius: "4px",
                  mb: 0.5,
                }}
              >
                AI Prompts
              </SuiButton>
            </SuiBox> */}
          </SuiBox>
        ) : null}

        {(jobconf.task_type == "gen.flat" || jobconf.task_type == "gen.flat.inpaint") &&
        sketchData?.imgurl &&
        viewType != "detail" ? (
          <SuiBox pb={1}>
            <SuiBox
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
              onClick={() => handleChangeViewType("detail")}
            >
              <ImageCardWrapper
                data={{ type: "image/*", url: sketchData?.imgurl }}
                alt="sketch img"
                width={"auto"}
                height={120}
                resizeType={"m_mfit"}
                style={{
                  cursor: "pointer",
                  height: "100%",
                  width: "auto",
                  maxHeight: 110,
                  borderRadius: 6,
                  overflow: "hidden",
                }}
              />
            </SuiBox>
          </SuiBox>
        ) : null}

        {jobconf.task_type == "fabric" ? (
          <SuiBox
            sx={{
              border: "1px dashed gray",
              mt: 1,
              height: 120,
              p: 0.5,
            }}
          >
            <SuiBox display="flex" justifyContent="space-evenly" alignItems="center" height="100%">
              <SuiBox sx={{ width: { xs: "100%", sm: "100%", md: "50%", lg: "50%" } }}>
                {sketchData?.imgurl ? (
                  <SuiBox
                    sx={{
                      position: "relative",
                      px: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    className="hover-parent"
                  >
                    {" "}
                    <ImageCardWrapper
                      data={{ type: "image/*", url: sketchData?.imgurl }}
                      alt="sketch img"
                      width={100}
                      height={100}
                      style={{
                        cursor: "pointer",
                        height: "100%",
                        width: "auto",
                        maxHeight: 110,
                        borderRadius: 6,
                        overflow: "hidden",
                      }}
                    />
                    <SuiBox
                      className="hover-children"
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <IconButton
                        size="small"
                        color="dark"
                        sx={{
                          backgroundColor: "#ffffff",
                          "&:hover": {
                            backgroundColor: "#e3e3e3",
                          },
                        }}
                        onClick={(e) => {
                          if (uploadSketchRef?.current) {
                            uploadSketchRef.current.open();
                          }
                        }}
                      >
                        <FileUploadIcon />
                      </IconButton>
                    </SuiBox>
                  </SuiBox>
                ) : (
                  <SuiBox sx={{ textAlign: "center" }}>
                    <SuiButton
                      variant="contained"
                      size="small"
                      color="dark"
                      sx={{
                        padding: "0px 8px",
                        fontSize: 12,
                        lineHeight: 0,
                        minHeight: 25,
                        minWidth: 60,
                        textTransform: "none",
                        borderRadius: "4px",
                      }}
                      onClick={(e) => {
                        if (uploadSketchRef?.current) {
                          uploadSketchRef.current.open();
                        }
                      }}
                    >
                      <FileUploadIcon sx={{ mr: "2px" }} />
                      Sketch
                    </SuiButton>
                  </SuiBox>
                )}
              </SuiBox>

              <SuiBox sx={{ width: { xs: "100%", sm: "100%", md: "50%", lg: "50%" } }}>
                {" "}
                {sketchData?.fabric_imgurl ? (
                  <SuiBox
                    sx={{
                      position: "relative",
                      px: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    className="hover-parent"
                  >
                    {" "}
                    <ImageCardWrapper
                      data={{ type: "image/*", url: sketchData?.fabric_imgurl }}
                      alt="fabric img"
                      width={100}
                      height={100}
                      style={{
                        cursor: "pointer",
                        height: "100%",
                        width: "auto",
                        maxHeight: 110,
                        borderRadius: 6,
                        overflow: "hidden",
                      }}
                    />
                    <SuiBox
                      className="hover-children"
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <IconButton
                        size="small"
                        color="dark"
                        sx={{
                          backgroundColor: "#ffffff",
                          "&:hover": {
                            backgroundColor: "#e3e3e3",
                          },
                        }}
                        onClick={(e) => {
                          console.log("click", uploadFabricRef?.current);
                          if (uploadFabricRef?.current) {
                            uploadFabricRef.current.open();
                          }
                        }}
                      >
                        <FileUploadIcon />
                      </IconButton>
                    </SuiBox>
                  </SuiBox>
                ) : (
                  <SuiBox sx={{ textAlign: "center" }}>
                    <SuiButton
                      variant="contained"
                      size="small"
                      color="info"
                      sx={{
                        padding: "0px 8px",
                        fontSize: 12,
                        lineHeight: 0,
                        minHeight: 25,
                        minWidth: 60,
                        textTransform: "none",
                        borderRadius: "4px",
                      }}
                      onClick={(e) => {
                        if (uploadFabricRef?.current) {
                          uploadFabricRef.current.open();
                        }
                      }}
                    >
                      <FileUploadIcon sx={{ mr: "2px" }} />
                      Fabric
                    </SuiButton>
                  </SuiBox>
                )}
              </SuiBox>
            </SuiBox>
          </SuiBox>
        ) : null}
      </Card>
      {jobconf.task_type == "gen.flat.sd" ? (
        <SuiBox>
          <Card sx={{ borderRadius: 1, mb: 2, boxShadow: ({ boxShadows: { md } }) => md }}>
            <SuiTypography
              variant="body1"
              sx={{ lineHeight: 1.6, backgroundColor: "#f3f3f3", px: 1 }}
            >
              Aspect Ratio
            </SuiTypography>
            <SuiBox p={1}>
              <SuiBox mx={1}>
                <SuiSelect
                  value={findAspectOption}
                  options={aspectRatioOptions}
                  onChange={(option) =>
                    setJobconf((prev) => ({ ...prev, aspect_ratio: option.value }))
                  }
                  size="small"
                />
              </SuiBox>
            </SuiBox>
          </Card>
        </SuiBox>
      ) : null}

      <SuiBox>
        <Card sx={{ borderRadius: 1, mb: 2, boxShadow: ({ boxShadows: { md } }) => md }}>
          <SuiTypography
            variant="body1"
            sx={{ lineHeight: 1.6, backgroundColor: "#f3f3f3", px: 1 }}
          >
            Generate Number
          </SuiTypography>
          <SuiBox p={1} px={2} pb={1.5}>
            <SuiTypography variant="caption" color="text">
              Fixed at <strong>1</strong> image per run (not configurable).
            </SuiTypography>
          </SuiBox>
        </Card>
      </SuiBox>
      {/* <SuiBox>
        <Card sx={{ borderRadius: 1, mb: 2, boxShadow: ({ boxShadows: { md } }) => md }}>
          <SuiTypography
            variant="body1"
            sx={{ lineHeight: 1.6, backgroundColor: "#f3f3f3", px: 1 }}
          >
            Advanced Settings
          </SuiTypography>
          <SuiBox p={1}>
            <SuiBox mx={2}>
              <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
                <SuiBox mb={0.5} lineHeight={0} display="inline-block">
                  <SuiTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    Inference Steps:
                  </SuiTypography>
                </SuiBox>
                <SuiBox mx={0.5}>
                  <Slider
                    min={15}
                    max={20}
                    step={1}
                    valueLabelDisplay="auto"
                    onChange={(e, value) =>
                      setJobconf((prev) => ({ ...prev, max_num_inference_steps: value }))
                    }
                    value={jobconf?.max_num_inference_steps || 20}
                  />
                </SuiBox>
              </SuiBox>
              <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
                <SuiBox mb={0.5} lineHeight={0} display="inline-block">
                  <SuiTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    Imagination Level:
                  </SuiTypography>
                </SuiBox>
                <SuiBox mx={0.5}>
                  <Slider
                    min={4}
                    max={10}
                    step={0.5}
                    valueLabelDisplay="auto"
                    onChange={(e, value) =>
                      setJobconf((prev) => ({ ...prev, guidance_scale: value }))
                    }
                    value={jobconf?.guidance_scale || 7}
                  />
                </SuiBox>
              </SuiBox>
              <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
                <SuiBox mb={0.5} lineHeight={0} display="inline-block">
                  <SuiTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                    textTransform="capitalize"
                  >
                    Control Level:
                  </SuiTypography>
                </SuiBox>
                <SuiBox mx={0.5}>
                  <Slider
                    min={0.5}
                    max={2}
                    step={0.1}
                    valueLabelDisplay="auto"
                    onChange={(e, value) =>
                      setJobconf((prev) => ({ ...prev, conditioning_scale: value }))
                    }
                    value={jobconf?.conditioning_scale || 1}
                  />
                </SuiBox>
              </SuiBox>
            </SuiBox>
          </SuiBox>
        </Card>
      </SuiBox> */}
      {addFashionTagVisible ? (
        <AddFashionTagModal
          jobconf={jobconf}
          setJobconf={setJobconf}
          handleClose={() => setAddFashionTagVisible(false)}
          visible={addFashionTagVisible}
          initSelected={selectedCat}
        />
      ) : null}
      {addMiniFashionTagVisible ? (
        <AddMiniFashionTagModal
          jobconf={jobconf}
          setJobconf={setJobconf}
          handleClose={() => setAddMiniFashionTagVisible(false)}
          visible={addMiniFashionTagVisible}
          initSelected={selectedCat}
          tagSubOptions={tagSubOptions}
        />
      ) : null}
      {inspiredTagsVisible ? (
        <InspirePromptTagModal
          jobconf={jobconf}
          setJobconf={setJobconf}
          handleClose={() => setInspiredTagsVisible(false)}
          visible={inspiredTagsVisible}
          promptRef={promptRef}
        />
      ) : null}
      {inspireVisible ? (
        <InspirePromptModal
          jobconf={jobconf}
          setJobconf={setJobconf}
          handleClose={() => setInspireVisible(false)}
          visible={inspireVisible}
          promptRef={promptRef}
        />
      ) : null}
    </SuiBox>
  );
};

export default DesignToolsCard;
